import ClusterDetailStatusColumn from "./components/operationLog/ClusterDetailStatusColumn.vue";
import ConventionalColumn from "./components/conventionalData/ConventionalColumn.vue";
import i18n from "@/i18n";

export const cardBottons = () => [
    {
        id: "delete",
        text: i18n.t("zhiji.common.delete"),
        type: "Button"
    },
    {
        id: "linkedQuestion",
        text: i18n.t("zhiji.cluster.RelateQues"),
        type: "Button"
    },
    {
        id: "createdQuestion",
        text: i18n.t("zhiji.cluster.addQues"),
        type: "Button"
    }
];

export const operateOptions = () => [
    {
        label: i18n.t("zhiji.cluster.logDetail.allQuestion"),
        value: ""
    },
    {
        label: i18n.t("zhiji.cluster.logDetail.deleted"),
        value: "2"
    },
    {
        label: i18n.t("zhiji.cluster.logDetail.related"),
        value: "4"
    },
    {
        label: i18n.t("zhiji.cluster.logDetail.created"),
        value: "3"
    }
];

export let logDetailsTableConfig = () => {
    return {
        columns: [
            {
                colId: "time",
                header: i18n.t("zhiji.cluster.logDetail.time"),
                type: "Text",
                width: "15%"
            },
            {
                colId: "question",
                header: i18n.t("zhiji.cluster.logDetail.question"),
                type: "Text",
                width: "35%"
            },
            {
                colId: "operator",
                header: i18n.t("zhiji.cluster.logDetail.operate"),
                type: "Text",
                width: "15%"
            },
            {
                colId: "status",
                header: i18n.t("zhiji.common.status"),
                type: "Custom",
                width: "15%",
                component: ClusterDetailStatusColumn
            },
            {
                colId: "result",
                header: i18n.t("zhiji.cluster.logDetail.result"),
                type: "Text",
                width: "35%"
            }
        ],
        isHideFooter: false
    };
};

export let conventionalTableConfig = () => {
    return {
        columns: [
            {
                colId: "check",
                header: "",
                type: "Checkbox",
                width: "37px"
            },
            {
                colId: "questionTime",
                header: i18n.t("zhiji.cluster.closeLoop.askTime"),
                type: "Text",
                width: "20%"
            },
            {
                colId: "question",
                header: i18n.t("zhiji.cluster.closeLoop.originalProblem"),
                type: "Text",
                width: "28%"
            },
            {
                colId: "channel",
                header: i18n.t("zhiji.cluster.closeLoop.channel"),
                type: "Text",
                width: "15%"
            },
            {
                colId: "operate",
                header: i18n.t("zhiji.common.operate"),
                type: "Custom",
                width: "35%",
                component: ConventionalColumn
            }
        ],
        isHideFooter: true
    };
};

export const conventionalOperate = () => [
    {
        id: "add",
        text: i18n.t("zhiji.cluster.closeLoop.addStandQues"),
        type: "Button"
    },
    {
        id: "linked",
        text: i18n.t("zhiji.cluster.closeLoop.linkSimilar"),
        type: "Button"
    },
    {
        id: "delete",
        text: i18n.t("zhiji.common.delete"),
        type: "Button"
    }
];
